import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

export default class c60v extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_c60rListsss: {c60r:[]},
  s_c60ri11d: ff.myDT_getDate('today'),
};

static op_loadSlcList = pd => 
  (pd.elm == 'c600') ?
    super.op_loadSlcList({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c('c600', `c600i11d >= "${pd.sttDate}" AND c600i11d <= "${pd.endDate}"`);
//ff.l('c60v 36: {}'.f(_cnd))
        return _cnd;
      }),
    })
  :super.op_loadSlcList(pd);

static op_loadList = pd => 
  (pd.elm == 'c60r') ?
    super.op_loadList({
      ld_sortss: [
        { fld: 'c60ri11s', dtn: 'desc', mode: 'nmb' }
      ],
      ...pd,
    })
  :super.op_loadList(pd);

static op_loadDtl = pd => 
  (pd.elm == 'c60r') ?
    super.op_loadDtl({
      dd_cldDefss: {
        c600: {
          elm: 'c600',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('c600', `c600br1k = ${_dd_datss.c60r.d_flds._key}`, false, false)
            return _cnd;
          },
        }
      },
      ...pd,
    })
  :super.op_loadDtl(pd);

$clp_loadLists = () => [ // 親を上書き
  c60v.op_loadList({
    elm: 'c60r',
  }),
];

$clp_loadDtls = () => [
  c60v.op_loadDtl({
    elm: 'c60r',
  }),
  c60v.op_loadVsnList({
    elm: 'c60r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c60rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      c60r: {
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            c60ri11s: _dd_datss.c60r.d_flds.c60ri11s ?? '',
          };
          return _d;
        },
        dd_cldDefss: {
          c600: {
            b_setPageKey: false,
            od_insDats: _dd_datss => {
              let _d = {
                c600br1k: global.t?.state.sgc_pageKey ?? -1,
                c600i11d: _dd_datss.c600.d_flds.c600i11d ?? '',
              };
              return _d;
            },
          },
        },

      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -10,
      d_hdrs: {
        pfx:
          (global.t?.state.sgc_pnlMode == 'list') ?
            '休館日一覧'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '休館日一覧'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '休館日変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '新規休館日登録'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -10,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_hdrs: {
              d_ctrs: {
              },
            },
            d_bdys: {
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -10,
                    state: 'sdld_c60rListsss',
                    dd_elmDefss: {
                      c60r: {
                        elm: 'c60r',
                        pfx: '対象年',
                        b_row: true,
                        b_hdr: true,
                        b_ttl: false,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_insFlds: cf.e('c60r').d_insFlds,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c60ri11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(5), },
                            d_bdys: { n_w: ic.s(5), },
                          }),
                        ]),
                      },
                    },
                  }),
                ])

              ],
            },
            d_btms: {
              d_news: {
                elm: 'c60r',
                pfx: '新規休館日設定',
                state: 'sdld_c60rDtlsss',
                opb_chkIns: global.t?.$opb_chk,
                d_insFlds: {
                  ...cf.e('c60r').d_insFlds, 
                  c60ri11i: ff.n(ff.myDT_cnv('year', ff.myDT_add('year', ff.myDT_getDate('today'), 1)))
                },
                dld_cldDatsss: {
                  c600: { // 利用室室情報
                    elm: 'c600',
                    d_insFlds: {
                      ...cf.e('c600').d_insFlds, 
                    },
                  },
                },
              },
            },
          }),

          ce.c(ce.Pnl, {
            key: -20,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
              d_htys: {
                elm: 'c60r',
                ld_iss: global.t?.state.sdld_c60rVsnListsss?.c60r,
                op_loadDtl: c60v.op_loadDtl,
              },
            },
            d_bdys: {
              d_msgBfrs:
              (global.t?.state.sgc_pnlMode == 'dtl' && ff.i(global.t?.state.sgc_pageMode, ['edit', 'new'])) ?
                {
//                pfx: `・右肩に×のある欄の空白部分を押すとカレンダーが表示されますので、該当される日にちを選んでください。×で取り消します。`, 
                  pfx:
                    (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
                      `■追加で表示される欄の空白部分を押すとカレンダーが表示されますので、該当する日にちを選んでください。\n■右肩の×で取り消します。`
                    : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
                      `■追加で表示される欄の空白部分を押すとカレンダーが表示されますので、該当する日にちを選んでください。\n■右肩の×で取り消します。`
                    : null,
                  n_mgnTop: ic.s(1),
                  d_stlCtas: {
                    minWidth: ic.gn_bdyW,
                  },
                }
              : null,
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [

                  ce.c(cr.InpTree, {
                    key: -10,
                    state: 'sdld_c60rDtlsss',
                    dd_elmDefss: {
                      c60r: {
                        elm: 'c60r',
                        b_row: false,
                        b_hdr: true,
                        b_ttl: true,
                        d_cmns: {
                          n_cnt: 1,
                        },
                        d_insFlds: cf.e('c60r').d_insFlds,
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c60ri11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(5), },
                            d_bdys: { n_w: ic.s(5), },
                          }),
                        ]),
                      },
                    },
                  }),

                ]),

//                (global.t?.state.sdld_c60rDtlsss?.c60r && ff.f(global.t?.state.sdld_c60rDtlsss?.c60r[0].d_flds.c60ri11s)) ?
                  ce.c(ce.Box, {
                    key: -20,
                    n_mgnTop: ic.s(1),
                  }, [
                    ce.c(cr.InpTree, {
                      key: -20,
                      state: 'sdld_c60rDtlsss',
                      dd_elmDefss: {
                        c60r: {
                          elm: 'c60r',
                          pfx: '休館日',
                          dd_cldDefss: {

                            c600: {
                              elm: 'c600',
                              b_row: false,
                              b_subHdr: false,
                              b_ttl: false,
                              d_btns: {
                                d_btrs: {
                                  pfx: '休館日を追加',
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                                d_dlts: {
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                              },
                              d_insFlds: cf.e('c60r').d_insFlds,
                              d_stlSubBdyCtas: {
                                borderWidth: 0,
                                borderTopWidth: ic.gn_bdrWNrw,
                                borderBottomWidth: ic.gn_bdrWNrw,
                                borderColor: ic.o_getCcd('d'),
                              },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('c600i11d', {
                                  d_mdls: 
                                    (global.t?.state.sdld_c60rDtlsss?.c60r && ff.f(global.t?.state.sdld_c60rDtlsss?.c60r[0].d_flds.c60ri11s)) ?
                                      {
                                        iniDate: `${global.t?.state.sdld_c60rDtlsss?.c60r[0].d_flds.c60ri11s}-01-01`,
                                        sttDate: `${global.t?.state.sdld_c60rDtlsss?.c60r[0].d_flds.c60ri11s}-01-01`,
                                        endDate: `${global.t?.state.sdld_c60rDtlsss?.c60r[0].d_flds.c60ri11s}-12-31`,
                                      }
                                    : null,
                                  d_hdrs: { n_w: ic.s(8), },
                                  d_bdys: { n_w: ic.s(8), },
                                }),
                              ]),
                            },
                          },

                        },
                      },
                      d_stlCtas: {
                        marginTop: ic.s(1.5),
                      },
                    }),
                  ])
//                : null,

              ],
            },
            d_btms: {
              d_btns: {
//                name: 'この休館日',
                name: 'この年の休館日',
                d_stlBtns: {
                  width: ic.s(14),
                },
              },
            },

          }),
        ],
      }
    })
  );
}

}

/*
*/
